<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="许可决定书名称" min-width="100" >
            <template slot-scope="scope">
              {{ scope.row.license_decision_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="许可文件名称">
            <template slot-scope="scope">
              {{ scope.row.license_file_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="许可类型">
            <template slot-scope="scope">
              {{ scope.row.license_type || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="许可机关名称">
            <template slot-scope="scope">
              {{ scope.row.license_agency_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="许可内容" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.license_content || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="决定日期">
            <template slot-scope="scope">
              {{ scope.row.decision_date || '-' }}
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'licenseList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '行政许可',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>